import { gql, useMutation } from "@apollo/client";

export const SEND_CONTACT_MESSAGE_MUTATION = gql`
  mutation SendContactMessage($contact: ContactInput!) {
    sendContactMessage(contact: $contact)
  }
`;

export const useSendContactMessage = () => {
  const [sendMessageMutation, { data, loading, error }] = useMutation(
    SEND_CONTACT_MESSAGE_MUTATION
  );

  const sendMessage = async (contact: { name: string; email: string; message: string }) => {
    try {
      const response = await sendMessageMutation({
        variables: { contact },
      });

      return response.data.sendContactMessage;
    } catch (err) {
      console.error("Failed to send contact message:", err);
      throw err;
    }
  };

  return {
    sendMessage,
    data,
    loading,
    error,
  };
};